import React from 'react';
import PropTypes from 'prop-types';

import dumbBem from 'dumb-bem';
import tx from 'transform-props-with';

import {
  Title,
  Description,
  Button,
} from 'components/landing/components';

import './Offer.css';


const dumbPosition = dumbBem('l-careers-offer');
const PositionWrp = tx(dumbPosition)('div');


export const Offer = ({
  title,
  locations,
  onNavigate,
}) => {
  return (
    <PositionWrp>
      <Title modifier="2">{title}</Title>
      <Description>{locations.join(' ')}</Description>
      <Button modifier="reversed-colors" onClick={onNavigate}>DETAILS</Button>
    </PositionWrp>
  );
};

Offer.propTypes = {
  title: PropTypes.string.isRequired,
  locations: PropTypes.arrayOf(PropTypes.string).isRequired,
  onNavigate: PropTypes.func.isRequired,
};

export default Offer;



// WEBPACK FOOTER //
// ./src/components/landing/pages/careers/Offer/Offer.js